import {
  cacheExchange,
  createClient as _createClient,
  dedupExchange,
  fetchExchange,
} from "urql";
import { commoneErrorExchange } from "~/graphqlClient/exchanges/commonErrorExchange";
import { cognitoAuthExchange } from "./exchanges/authExchange";
import { omitTypenameExchange } from "./exchanges/omitTypenameExchange";

export const createClient = () => {
  return _createClient({
    url: import.meta.env.VITE_API_ENDPOINT,
    suspense: true,
    exchanges: [
      omitTypenameExchange,
      dedupExchange,
      cacheExchange,
      cognitoAuthExchange,
      commoneErrorExchange,
      fetchExchange,
    ],
  })
};
